$(document).ready(function() {
  var $lista = $("#product-grid");
  var $elementosLi = $lista.find("li");
  
  if ($elementosLi.length > 7) {
      var $divNuevo = $(
        '<li class="grid__item imagen-collection-page">' +
          '<a href="/pages/how-to-experts-challah-board">' +
            '<video autoplay playsinline loop muted src="https://cdn.shopify.com/videos/c/o/v/7d4d5f844f8f4a759a8d51388c2a14cb.mp4"></video>' + 
            '<div class="overlay">'+
              '<h4>How to choose</h4>' +
              '<p>the perfect Challah Board</p>'+
              '<span>Know More</span>' +
            '</div>' +
          '</a>' +
        '</li>'
      );
      $elementosLi.eq(4).after($divNuevo);
  } else {
      var $divNuevo = $(
        '<li class="grid__item imagen-collection-page">' +
          '<a href="/pages/how-to-experts-challah-board">' +
            '<video autoplay playsinline loop muted src="https://cdn.shopify.com/videos/c/o/v/7d4d5f844f8f4a759a8d51388c2a14cb.mp4"></video>' + 
            '<div class="overlay">'+
              '<h4>How to choose</h4>' +
              '<p>the perfect Challah Board</p>'+
              '<span>Know More</span>' +
            '</div>' +
          '</a>' +
        '</li>'
      );
      $elementosLi.eq(1).after($divNuevo);
  };
});